
import { ChallengeData } from "@/models/Base/ChallengeData";
import { Game } from "@/models/Game";
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { cloneDeep, isEqual } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AlertBoxEditable from "../../../Base/AlertBoxEditable.vue";
import DeleteBoxEditable from "../../../Base/DeleteBoxEditable.vue";
import ChallengeBox from "../../../Base/ChallengeBox.vue";
import PoiWitnessTable from "../Tables/PoiWitnessTable.vue";

@Component({
  components: {
    ChallengeBox,
    PoiWitnessTable,
    AlertBoxEditable,
    DeleteBoxEditable,
  },
})
class PoiWitness extends Vue {
  @Prop({ default: null }) readonly mapPoi!: ManhuntMapPoi;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  getVariantSelected = "alt_0";
  getVariantArray: string[] = [];
  answer1 = "";
  answer2 = "";
  answer3 = "";
  question1 = "";
  question2 = "";
  question3 = "";
  hint = "";
  informant = "";
  buttonLabel = "";
  getTargetValue = "";
  mapPoiClone = {} as ManhuntMapPoi;

  get getChallengeData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    try {
      if (this.mapPoi.witness.content[this.getVariantSelected] !== undefined) {
        if (
          this.mapPoi.witness.content[this.getVariantSelected].main.txt !==
          undefined
        ) {
          challengeData.text = this.mapPoi.witness.content[
            this.getVariantSelected
          ].main.txt.en;
        } else {
          challengeData.text = "";
        }
        challengeData.image =
          this.mapPoi.witness.content[this.getVariantSelected].main.h_thumb ||
          "";
        if (
          this.mapPoi.witness.content[this.getVariantSelected].main.audio !==
          undefined
        ) {
          challengeData.audio = this.mapPoi.witness.content[
            this.getVariantSelected
          ].main.audio || { en: "" };
        } else {
          challengeData.audio = { en: "" };
        }
        if (
          this.mapPoi.witness.content[this.getVariantSelected].main.video !==
          undefined
        ) {
          challengeData.video = this.mapPoi.witness.content[
            this.getVariantSelected
          ].main.video || { en: "" };
        } else {
          challengeData.video = { en: "" };
        }
      } else {
        challengeData.text = "";
        challengeData.image = "";
        challengeData.audio = { en: "" };
        challengeData.video = { en: "" };
      }
    } catch (error) {
      console.log(error);
    }
    return challengeData;
  }
  get getVariant(): string[] {
    return this.getVariantArray;
  }

  get disabledTarget(): boolean {
    if (this.getVariant.length == 1) {
      return false;
    }
    return true;
  }

  get getVariantName(): string {
    var index = this.getVariant.findIndex((x) => x === this.getVariantSelected);
    if (this.getVariant.length - 1 == index) {
      return "NONE";
    }
    return this.getVariant[index + 1];
  }

  get getPreviousName(): string {
    var index = this.getVariant.findIndex((x) => x === this.getVariantSelected);
    if (this.getVariant.length == 1) {
      return "alt_0";
    }
    return this.getVariant[index - 1];
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/img/poi/"
    );
  }

  get getAudioPath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/audio/poi/"
    );
  }
  get getVideoPath(): string {
    return (
      "/gametype/" +
      this.gameData.gt_uid +
      "/seasons/" +
      this.gameData.seas_uid +
      "/video/poi/"
    );
  }

  get getIsLastVariant(): boolean {
    var index = this.getVariant.findIndex((x) => x === this.getVariantSelected);
    if (this.getVariant.length - 1 == index) {
      return false;
    }
    return true;
  }

  get getNextVariantSelected(): string {
    var nextNumber: number = parseInt(
      this.getVariantSelected.replace(/^\D+/g, "")
    );
    nextNumber = nextNumber + 1;
    return "alt_" + nextNumber;
  }

  get getDeleteMessage(): string {
    return (
      "Delete Witness variant? Variant " +
      this.getVariantSelected +
      " will have it's targeting set to none. Please check any remaining routines as this may cause breaks in the chain.  Proceed?"
    );
  }

  //This is one big hack at the moment. Will need to refractor at later date
  saveValues(): void {
    try {
      delete this.mapPoi.witness.content[this.getVariantSelected].wit_q;
      delete this.mapPoi.witness.content[this.getVariantSelected].hint;
      delete this.mapPoi.witness.content[this.getVariantSelected].inf;
      var q1 = this.getAnswerQuestion("q1", this.question1, this.answer1);
      var q2 = this.getAnswerQuestion("q2", this.question2, this.answer2);
      var q3 = this.getAnswerQuestion("q3", this.question3, this.answer3);

      if (q1 !== {} || q2 !== {} || q3 !== {}) {
        this.mapPoi.witness.content[this.getVariantSelected].wit_q = {
          ...q1,
          ...q2,
          ...q3,
        };
      }
      if (this.informant.trim().length > 0) {
        this.mapPoi.witness.content[this.getVariantSelected].inf = {
          txt: { en: this.informant },
        };
      }
      if (this.hint.trim().length > 0) {
        this.mapPoi.witness.content[this.getVariantSelected].hint = {
          txt: { en: this.hint },
        };
      }
      if (
        this.mapPoi.witness.content[this.getVariantSelected].triggers ===
        undefined
      ) {
        this.mapPoi.witness.content[this.getVariantSelected].triggers = {
          btn_label: {
            txt: { en: this.buttonLabel.trim() },
          },
        };
      } else {
        this.mapPoi.witness.content[
          this.getVariantSelected
        ].triggers!.btn_label = { txt: { en: this.buttonLabel.trim() } };
      }
    } catch (error) {
      console.log(error);
    }
  }

  setOptionalFields(): void {
    try {
      this.question1 =
        this.mapPoi.witness.content[this.getVariantSelected].wit_q?.q1?.q.en ||
        "";
      this.question2 =
        this.mapPoi.witness.content[this.getVariantSelected].wit_q?.q2?.q.en ||
        "";
      this.question3 =
        this.mapPoi.witness.content[this.getVariantSelected].wit_q?.q3?.q.en ||
        "";
      this.answer1 =
        this.mapPoi.witness.content[this.getVariantSelected].wit_q?.q1?.a.en ||
        "";
      this.answer2 =
        this.mapPoi.witness.content[this.getVariantSelected].wit_q?.q2?.a.en ||
        "";
      this.answer3 =
        this.mapPoi.witness.content[this.getVariantSelected].wit_q?.q3?.a.en ||
        "";
      this.hint =
        this.mapPoi.witness.content[this.getVariantSelected].hint?.txt.en || "";
      this.informant =
        this.mapPoi.witness.content[this.getVariantSelected].inf?.txt.en || "";
      this.buttonLabel =
        this.mapPoi.witness.content[this.getVariantSelected].triggers?.btn_label
          ?.txt.en || "";
      this.getTargetValue =
        this.mapPoi.witness.content[this.getVariantSelected].triggers
          ?.target_id || "";
    } catch (error) {
      console.log(error);
    }
  }

  created(): void {
    this.mapPoiClone = cloneDeep(this.mapPoi);
    this.getVariantArray = Object.keys(this.mapPoi.witness.content);
    this.setOptionalFields();
  }

  onValueChanged(isDelete: boolean): void {
    if (!isDelete) {
      this.saveValues();
    }
    if (!this.mapPoi.witness.suspect) {
      this.mapPoi.witness.guilt = false;
    }
    if (!isEqual(this.mapPoi, this.mapPoiClone)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", this.mapPoi);
  }

  getAnswerQuestion(type: string, question: string, answer: string): any {
    if (question.trim().length > 0 && answer.trim().length > 0) {
      return {
        [type]: {
          q: { en: question },
          a: { en: answer },
        },
      };
    } else {
      return {};
    }
  }
  updateTempObject(challengeData: any): void {
    if (
      this.mapPoi.witness.content[this.getVariantSelected].triggers ===
      undefined
    ) {
      this.mapPoi.witness.content[this.getVariantSelected].triggers = {
        btn_label: { txt: { en: this.buttonLabel } },
        inv_req:
          challengeData.content[this.getVariantSelected].triggers.inv_req,
      };
    } else {
      this.mapPoi.witness.content[
        this.getVariantSelected
      ].triggers!.inv_req! = challengeData.content[
        this.getVariantSelected
      ].triggers.inv_req;
    }
    this.onValueChanged(true);
  }

  openDialogBox(): void {
    this.$bvModal.show("team-modal-alert-edit");
  }

  alertOk(): void {
    this.mapPoi.witness.content[this.getNextVariantSelected] = {
      main: {
        h_thumb: "",
        img: "",
        txt: { en: "" },
        video: { en: "" },
        audio: { en: "" },
      },
    };
    this.mapPoi.witness.content[this.getVariantSelected].triggers = {
      target_id: this.getNextVariantSelected,
    };
    this.getVariant.push(this.getNextVariantSelected);
    this.getVariantSelected = this.getNextVariantSelected;
    this.onValueChanged(true);
  }

  onDataChange(challenge: ChallengeData): void {
    if (
      this.mapPoi.witness.content[this.getVariantSelected].main.txt ===
      undefined
    ) {
      this.mapPoi.witness.content[this.getVariantSelected].main.txt = {
        en: challenge.text,
      };
    } else {
      this.mapPoi.witness.content[this.getVariantSelected].main.txt.en =
        challenge.text;
    }
    this.mapPoi.witness.content[this.getVariantSelected].main.h_thumb =
      challenge.image;
    this.mapPoi.witness.content[this.getVariantSelected].main.audio =
      challenge.audio;
    this.mapPoi.witness.content[this.getVariantSelected].main.video =
      challenge.video;
    this.onValueChanged(false);
  }

  onVariantChanged(event: string): void {
    this.getVariantSelected = event;
    this.setOptionalFields();
  }
  openDeleteDialog(): void {
    this.$bvModal.show("team-modal-delete-editable");
  }
  deleteItem(): void {
    delete this.mapPoi.witness.content[this.getVariantSelected];
    delete this.mapPoi.witness.content[this.getPreviousName].triggers;
    this.getVariantSelected = this.getPreviousName;
    this.getVariant.pop();
    this.onValueChanged(true);
    this.$bvModal.hide("team-modal-delete-editable");
  }

  @Watch("isSavedOrDiscard")
  onisSaveOrDiscardChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }
  @Watch("mapPoi")
  onContentChange(value: ManhuntMapPoi): void {
    this.mapPoiClone = cloneDeep(value);
    this.getVariantArray = Object.keys(this.mapPoi.witness.content);
  }
}

export default PoiWitness;
